/**
 * LinkedIn's follow-up never on a weekend (Sofia, Oct 28 2026). LinkedIn sends it exactly N days
 * after the InMail; when that day is a Saturday or Sunday (Berlin), the page sets the days to the
 * Monday after instead — or the Friday before when that would go past the role's maximum of 30.
 * Same rule as `weekdayFollowUpDays` in proxy-server/lib/outreachFollowUp.js, which stores the due date.
 */
const DAY_MS = 24 * 60 * 60 * 1000;
export const MAX_FOLLOW_UP_DAYS = 30;

const BERLIN_WEEKDAY = new Intl.DateTimeFormat('en-GB', { weekday: 'short', timeZone: 'Europe/Berlin' });
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** Day of the week in Berlin, 0 = Sunday … 6 = Saturday. */
export const berlinWeekday = (ms: number) => WEEKDAYS.indexOf(BERLIN_WEEKDAY.format(new Date(ms)));

export function weekdayFollowUpDays(fromMs: number, days: number, max = MAX_FOLLOW_UP_DAYS): number {
  if (!Number.isInteger(days) || days < 1) return days;
  const weekday = berlinWeekday(fromMs + days * DAY_MS);
  if (weekday !== 0 && weekday !== 6) return days;
  const later = days + (weekday === 6 ? 2 : 1);
  return later <= max ? later : days - (weekday === 6 ? 1 : 2);
}
